import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const taskListSlice = createSlice({
  name: "taskList",
  initialState,
  reducers: {
    invalidateTaskList: () => ({}),
    updateTaskList: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.data,
      };
    },
  },
});

export const { invalidateTaskList, updateTaskList } = taskListSlice.actions;

export default taskListSlice.reducer;
